"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _List = _interopRequireDefault(require("../List"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var CollapseList = (0, _List.default)(['collapse'], 'fast');

var Panel =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Panel, _PureComponent);

  function Panel(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.isPristine = true;
    return _this;
  }

  var _proto = Panel.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        background = _this$props.background,
        color = _this$props.color,
        isActive = _this$props.isActive,
        collapsible = _this$props.collapsible,
        collapsed = _this$props.collapsed;
    if (!isActive && this.isPristine) return null;
    this.isPristine = false;
    var style = Object.assign({
      background: background || '#fff',
      color: color
    }, this.props.style);
    var className = (0, _classnames.default)((0, _styles.tabsClass)('panel', isActive && 'show'), this.props.className);

    var result = _react.default.createElement("div", {
      style: style,
      className: className
    }, children);

    if (!collapsible) return result;
    return _react.default.createElement(CollapseList, {
      show: !collapsed
    }, result);
  };

  return Panel;
}(_react.PureComponent);

Panel.isTabPanel = true;
Panel.propTypes = {
  background: _propTypes.default.string,
  className: _propTypes.default.string,
  collapsed: _propTypes.default.bool,
  collapsible: _propTypes.default.bool,
  color: _propTypes.default.string,
  children: _propTypes.default.any,
  isActive: _propTypes.default.bool,
  style: _propTypes.default.object
};
var _default = Panel;
exports.default = _default;